import toast from 'react-hot-toast'
import { formatMoney } from '../../lib/money'
import { isInsufficientBalanceResponse } from '../../lib/billing'

/**
 * Show the "wallet too low — Top up" call to action for a 402
 * insufficient_balance answer from POST /api/v2/verify/initialize.
 * Returns true when it handled the response.
 */
export function handleInsufficientBalance(status: number | undefined, body: any): boolean {
  if (!isInsufficientBalanceResponse(status, body)) return false
  const price = typeof body?.price_cents === 'number' ? formatMoney(body.price_cents) : null
  const balance = typeof body?.balance_cents === 'number' ? formatMoney(body.balance_cents) : null
  toast.error(
    t => (
      <span style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <span>
          <b style={{ display: 'block' }}>Wallet balance too low</b>
          <span style={{ opacity: 0.8, fontSize: 13 }}>
            {balance && price ? `${balance} available, ${price} needed for a live verification.` : 'Top up your wallet to start live verifications.'}
          </span>
        </span>
        <a
          href="/developer/billing"
          onClick={() => toast.dismiss(t.id)}
          style={{ background: '#f97316', color: '#fff', borderRadius: 999, padding: '6px 14px', fontWeight: 600, fontSize: 13, textDecoration: 'none' }}
        >
          Top up
        </a>
      </span>
    ),
    { id: 'insufficient-balance', duration: 10000 },
  )
  return true
}
